import { render, staticRenderFns } from "./ValidateCompliance.vue?vue&type=template&id=fa73709a&scoped=true"
import script from "./ValidateCompliance.vue?vue&type=script&lang=js"
export * from "./ValidateCompliance.vue?vue&type=script&lang=js"
import style0 from "./ValidateCompliance.vue?vue&type=style&index=0&id=fa73709a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73709a",
  null
  
)

export default component.exports